import 'angular:locale/data:en-US';
import 'zone.js';(globalThis.$localize ??= {}).locale = "en-US";
